import NavigationComponent from "../../navigation/navigation.component";
import { Background, Header1, PFEB, ProjDeets, PData, OppGradient, Alinks, Gradient, GalleryContainer, GalleryImages, GalleryArrow} from "./fall-english-breggfast.styles";
import { useContext } from "react";
import { GallaryContext } from "../../contexts/image-gallary.context";
import LB from '../../images/games/LeftButton.png';
import RB from '../../images/games/RightButton.png';


const FallEnglishBreggfest = () => {

    const {currentFebImage, febGallaryNext, febGallaryPrevious} = useContext(GallaryContext);

    return(
        <Background>
            <NavigationComponent></NavigationComponent>

            <Gradient></Gradient>

            <Header1>Fall English Breggfast</Header1>
            <PFEB>A co-op game in which you and a friend must fight to see who serves the customer first! Catch the food falling from the sky to make a complete meal and bring it to the customer as soon as you can! Don't pick up the wrong food though, or you'll have to throw your whole meal away and start from scratch! Be careful of your competitor, because they can stun you with a good punch to the side, leaving you unable to pick up any food for a period of time!</PFEB>

            <PFEB>As the sole programmer on this project, I programmed all the gameplay including player movement, food detection, falling food, etc.  Please view this project on <Alinks href="https://github.com/BrieAnnaAllen/FallEnglishBreakfast/tree/Chitag-Iteration">Github</Alinks></PFEB>

            <PFEB>Fall English Breggfest was created as a challenge created for us during our capstone to make a completed game in 4 weeks.  Being a team of 5, three artists, one sound designer and one programmer,  we attempted to produce an idea that would play on our strengths as a team.  It was clear to us that a 2d game would be best for completing in four weeks art wise, despite not having much experience in 2d programming upon beginning this project. </PFEB>

            <PFEB>Over the next four weeks, I spent my time programming everything from movement, to a basic random falling algorithm and more.  At the end of the four weeks, we have a full fledged game that all of us could be proud of.  It was the very first game I've worked on with a team larger than just myself.</PFEB>

            <ProjDeets>
                <PData><strong>Project Type:</strong> Game <br/>
                <strong>Date Completed:</strong> September 2018<br/>
                <strong>Role:</strong> Lead Programmer<br/>
                <strong>Skills Used:</strong> Unity, C#, Visual Studio, Github, Github Desktop</PData>
            </ProjDeets>

            <GalleryContainer>
                <GalleryArrow left src={LB} onClick={febGallaryPrevious}></GalleryArrow>
                <GalleryImages src={currentFebImage} ></GalleryImages>
                <GalleryArrow right src={RB} onClick={febGallaryNext}></GalleryArrow>
            </GalleryContainer>

            <OppGradient></OppGradient>
        </Background>
    )
}

export default FallEnglishBreggfest;